import { render, staticRenderFns } from "./CaptchaImage.vue?vue&type=template&id=42f2b94a&scoped=true"
import script from "./CaptchaImage.vue?vue&type=script&lang=js"
export * from "./CaptchaImage.vue?vue&type=script&lang=js"
import style0 from "./CaptchaImage.vue?vue&type=style&index=0&id=42f2b94a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f2b94a",
  null
  
)

export default component.exports